import { IconClock, IconRefresh } from '../icons'
import { asset } from '../lib/asset'

/**
 * 作业进行中的标题条。
 *
 * 背景：首屏原先在这里，标题、一句话、拖入区都归它管。2026-09-10 首屏重做之后
 *   那一份挪进了 Landing（左右两栏，右边是案例对比器），这里只剩收起态。
 * 设计意图：作业一开跑，用户要看的是自己那张图的数字，不是再读一遍产品介绍。
 *   收起而不是整个删掉，是因为从工具箱点进来的人需要一个「我在哪个工具里」的锚点。
 * 关键约束：收起态一般要带重置入口，否则想换张图只能刷新页面，而刷新会丢掉
 *   已经拿到的诊断结果。但作业正在跑的时候不能给这个入口：那时米粒已经预扣，
 *   一次误点就是白花一次钱，而作业本来马上就会自己结束。所以调用方在处理中不传 onReset。
 *   「我处理过的」没有这一条限制，跑着的时候照给：它只是拉开一层抽屉，
 *   手里这趟一个字都不动（2026-09-11 用户问「历史记录只能首页看？」）。
 */
export function Hero({ compact, onReset, onHistory }: {
  compact: boolean
  onReset?: () => void
  /** 拉开「我处理过的」。没有这个入口时（录像那一卷）整颗按钮不出现。 */
  onHistory?: () => void
}) {
  if (!compact) return null

  return (
    <div className="hero-slim">
      <div className="hero-slim-t">
        {/* 标题点得动，回工具首页（2026-09-12 用户裁决）。与右边那颗「换一张图」不是
            同一件事：这条是导航，作业只松手不取消；那颗是「这趟不要了」，会取消作业，
            所以处理中不给。 */}
        <a href={asset('/')}><b>数字涟漪修复</b></a>
        <span>全幅原像素分析 · 不缩放</span>
      </div>
      <div className="hero-slim-a">
        {onHistory && (
          <button className="btn btn-sm btn-ghost" onClick={onHistory}>
            <IconClock size={14} />我处理过的
          </button>
        )}
        {onReset && (
          <button className="btn btn-sm" onClick={onReset}>
            <IconRefresh size={14} />换一张图
          </button>
        )}
      </div>
    </div>
  )
}
